/**
 * Production-safe logger.
 *
 * In development (`npm start`) all messages are forwarded to the real console.
 * In production builds the methods are no-ops, so nothing leaks to the
 * browser DevTools.
 *
 * Usage:
 *   import logger from '../../utils/logger';
 *   logger.error('Something went wrong', err);
 */

const isDev = process.env.NODE_ENV === 'development';

const noop = () => {};

const logger = {
  log:   isDev ? console.log.bind(console)   : noop,
  warn:  isDev ? console.warn.bind(console)  : noop,
  error: isDev ? console.error.bind(console) : noop,
  info:  isDev ? console.info.bind(console)  : noop,
};

export default logger;
